export const workloadItems = Array.from({ length: 11 }, (v, k) => k * 10).map((i) => ({ id: i, name: i + '%' }));
